import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Typography } from '@mui/material';
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';
import IndividualProgressIndicator from 'feature/loading-management/create-new-common/IndividualProgressIndicator';
import { useAddTrailerToLocationMutation } from '../../trailerStatusEndpoints';

const locationProgressStyles = {
  alignItems: 'center',
  borderBottom: `solid 1px`,
  borderBottomColor: 'graphic.light',
  display: 'grid',
  gridAutoColumns: 'min-content 262px min-content',
  gridAutoFlow: 'column',
  gridGap: 2,
  p: (2, 3),
};
const locationTitleStyles = {
  maxWidth: '260px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const SubmittedLocation = ({ updateHandler, locationId, name, trailerId }) => {
  const [submitTrailer, { isError, isSuccess }] = useAddTrailerToLocationMutation();

  useEffect(() => {
    submitTrailer({ locationId, trailerId })
      .unwrap()
      .then(() => {
        updateHandler();
      })
      .catch(err => {
        updateHandler({ err, error: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box sx={locationProgressStyles}>
        <CheckBoxRoundedIcon sx={{ color: 'graphic.main', mr: 1 }} />
        <Typography color="textPrimary" sx={locationTitleStyles} variant="body1">
          {name}
        </Typography>
        <IndividualProgressIndicator
          error={isError ? 'error' : ''}
          isSuccessful={isSuccess ?? false}
        />
      </Box>
      <Divider />
    </>
  );
};

SubmittedLocation.propTypes = {
  locationId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  trailerId: PropTypes.string.isRequired,
  updateHandler: PropTypes.func.isRequired,
};

export default SubmittedLocation;
